import * as VolumeService from '../services/VolumeService';

// CaptionTextProcessorService - processes caption text for accessibility
class CaptionTextProcessorService {
	constructor() {
		this.currentTemp = 72; // this is for demo purposes
	}

	setCurrentTemp(temp) {
		this.currentTemp = temp;
	}

	processCaptionText(text) {
		if (!text || typeof text !== 'string') return '';
		
		// Debug: Check if VolumeService functions are available
		console.log('🔍 VolumeService.getVolumeUpNextValue:', typeof VolumeService.getVolumeUpNextValue);
		console.log('🔍 VolumeService.getVolumeDownNextValue:', typeof VolumeService.getVolumeDownNextValue);
		
		// Replace template variables
		let processed = text.replace(/{%\s*degrees\s*%}/gi, `${this.currentTemp}`);
		
		const volumeUpNext = VolumeService.getVolumeUpNextValue ? VolumeService.getVolumeUpNextValue() : 0;
		const volumeDownNext = VolumeService.getVolumeDownNextValue ? VolumeService.getVolumeDownNextValue() : 0;
		
		console.log('🔍 volumeUpNext:', volumeUpNext);
		console.log('🔍 volumeDownNext:', volumeDownNext);
		
		processed = processed.replace(/{%\s*getVolumeUp\s*%}/gi, `${Math.ceil(volumeUpNext * 100)}`);
		processed = processed.replace(/{%\s*getVolumeDown\s*%}/gi, `${Math.ceil(volumeDownNext * 100)}`);
		return processed;
	}
}

export const captionTextProcessorService = new CaptionTextProcessorService();
